import { useEffect, useRef } from 'react';

export default function Navbar() {
  const rootRef = useRef<HTMLElement | null>(null);

  useEffect(() => {
    const el = rootRef.current;
    if (!el) return;

    // The hero section is 500vh tall (see DandelionHero). Match the same
    // progress calculation so the navbar blows away in sync with everything
    // else in the hero.
    const heroEl = document.querySelector('.hero') as HTMLElement | null;

    const onScroll = () => {
      let progress = 0;
      if (heroEl) {
        const rect = heroEl.getBoundingClientRect();
        const scrolled = -rect.top;
        const max = heroEl.offsetHeight - window.innerHeight;
        progress = Math.min(1, Math.max(0, scrolled / max));
      } else {
        progress = Math.min(1, window.scrollY / (window.innerHeight * 4));
      }

      // Navbar leaves early in the wave — it's the very top layer.
      const delay = 0.02;
      const span = Math.max(0.15, 1 - delay);
      const local = Math.min(1, Math.max(0, (progress - delay) / span));
      const eased = local * local * local;
      const tx = 900 * eased;
      const ty = -400 * eased;
      const rot = 5 * eased;
      const opacity = Math.max(0, 1 - local * 1.3);
      const blur = eased * 6;

      el.style.transform = `translate3d(${tx}px, ${ty}px, 0) rotate(${rot}deg)`;
      el.style.opacity = String(opacity);
      el.style.filter = `blur(${blur}px)`;
      el.style.pointerEvents = opacity < 0.1 ? 'none' : '';
    };

    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header
      ref={rootRef}
      className="pointer-events-none fixed inset-x-0 top-0 z-50 will-change-transform"
      style={{ transition: 'filter 120ms linear' }}
    >
      <div className="mx-auto flex h-20 w-full max-w-[1400px] items-center justify-between px-8 md:px-12">
        <a
          href="#"
          className="pointer-events-auto font-display text-[15px] font-semibold tracking-[3px] text-white/90"
        >
          DL.
        </a>

        <nav className="pointer-events-auto hidden items-center gap-2 rounded-full border border-white/15 bg-white/[0.04] px-2 py-2 backdrop-blur-md md:flex">
          {[
            { label: 'Home', active: true },
            { label: 'Stories' },
            { label: 'About' },
            { label: 'Contacts' },
          ].map((item) => (
            <a
              key={item.label}
              href="#"
              className={`whitespace-nowrap rounded-full px-5 py-1.5 text-[12px] tracking-[2px] transition-colors ${
                item.active
                  ? 'bg-white text-black'
                  : 'text-white/70 hover:text-white'
              }`}
            >
              {item.label.toUpperCase()}
            </a>
          ))}
        </nav>

        <a
          href="#"
          aria-label="Instagram"
          className="pointer-events-auto flex h-9 w-9 items-center justify-center rounded-full border border-white/15 text-white/80 transition-colors hover:bg-white hover:text-black"
        >
          <i className="ri-instagram-line text-[16px]"></i>
        </a>
      </div>
    </header>
  );
}